export default "__VITE_ASSET__DZkWW_uA__"